import { Capacitor } from '@capacitor/core';

export const PlatformService = {
  isNative: () => Capacitor.isNativePlatform(),
  isWeb: () => !Capacitor.isNativePlatform(),
  getPlatform: () => Capacitor.getPlatform(),
  isIOS: () => Capacitor.getPlatform() === 'ios',
  isAndroid: () => Capacitor.getPlatform() === 'android',

  // iPad detection
  isIPad: () => {
    // For native iOS app on iPad
    if (Capacitor.getPlatform() === 'ios') {
      // Check if running on iPad using user agent
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes('ipad') ||
        (ua.includes('macintosh') && 'ontouchend' in document);
    }

    // For web on iPad (Safari reports as Mac in user agent)
    if (typeof window !== 'undefined') {
      const ua = navigator.userAgent.toLowerCase();
      return ua.includes('ipad') ||
        (ua.includes('macintosh') && navigator.maxTouchPoints > 1);
    }

    return false;
  },

  // Check if device should use touch navigation for reader
  // This includes all mobile devices AND iPads
  shouldUseTouchNavigation: () => {
    return PlatformService.isNative() || PlatformService.isIPad();
  },

  // Check if running in a mobile browser (not native app)
  isMobileBrowser: () => {
    // Return false if it's a native app
    if (Capacitor.isNativePlatform()) {
      return false;
    }

    // Check if user agent indicates mobile device
    if (typeof window !== 'undefined' && navigator?.userAgent) {
      const ua = navigator.userAgent.toLowerCase();
      return /iphone|ipod|android|mobile|webos|blackberry|iemobile|opera mini/i.test(ua);
    }

    return false;
  },

  // Helper for conditional rendering
  select: <T>(native: T, web: T): T => {
    return Capacitor.isNativePlatform() ? native : web;
  }
};